// achatsMobileShared.js — helpers d'affichage de l'écran Achats mobile.

// GestionAchat.tsx:88-91
const PERMISSION_ROOT = {
  purchase: "Gestion Commerciale.Approvisionnement.Achats.Achat",
  purchase_order: "Gestion Commerciale.Approvisionnement.Achats.BonCommande",
};

export const permsFor = (orderType) => {
  const root = PERMISSION_ROOT[orderType] || PERMISSION_ROOT.purchase;
  return {
    view: `${root}.view`,
    create: `${root}.create`,
    edit: `${root}.edit`,
    delete: `${root}.delete`,
    generatePdf: `${root}.generate_pdf`,
    viewPayments:
      orderType === "purchase"
        ? "Gestion Commerciale.Approvisionnement.Achats.Achat.view_payments"
        : null,
    createPayment:
      orderType === "purchase"
        ? "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.create"
        : null,
  };
};

export const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString("fr-FR");
};

/** Statut de paiement → ton de `Pill` du kit .epm. */
export const paymentPill = (status) => {
  const s = String(status || "Non payé");
  if (s === "Payé") return { tone: "ok", label: "Payé" };
  if (s === "Partiel" || s === "Partiellement payé") return { tone: "warn", label: "Partiel" };
  return { tone: "danger", label: "Non payé" };
};

/** Statut de commande → ton de `Pill`. */
export const orderPill = (order) => {
  const s = String(order.order_status || "En attente");
  if (s === "Annulé") return { tone: "danger", label: s };
  if (s === "En attente") return { tone: "draft", label: s };
  return { tone: "ok", label: s };
};

export const supplierNameOf = (order, fournisseurs = []) =>
  order.supplier_name ||
  order.entity_name ||
  order.user_name ||
  fournisseurs.find((f) => Number(f.id) === Number(order.user_id))?.name ||
  "Fournisseur inconnu";

/**
 * Reproduit la ternaire du desktop (GestionAchat.tsx:4121-4200) : les trois actions
 * sont mutuellement exclusives. Une commande payée exige un avoir ou un retour
 * et n'expose donc pas d'action destructive directe.
 */
export const destructiveActionFor = (order, canDelete, showPayments) => {
  if (!canDelete) return null;
  if (order.is_deleted === 1) return "restore";
  if (showPayments && num(order.paid_amount) > 0) return null;
  if (order.is_deletable === 0) return null;
  return "delete";
};

/** Frais annexes portés par la commande (colonnes extra_cost_*). */
export const extraCostsOf = (order) => [
  { key: "transport", label: "Transport", amount: num(order.extra_cost_transport), included: num(order.extra_cost_transport_included ?? 1) !== 0 },
  { key: "assurance", label: "Assurance", amount: num(order.extra_cost_assurance), included: num(order.extra_cost_assurance_included ?? 1) !== 0 },
  { key: "douane", label: "Douane", amount: num(order.extra_cost_douane), included: num(order.extra_cost_douane_included ?? 1) !== 0 },
  { key: "autres", label: "Autres frais", amount: num(order.extra_cost_autres), included: num(order.extra_cost_autres_included ?? 1) !== 0 },
];
